import {
  isSquareOrderingAgent,
  isStreamOrderingAgent,
} from "../utils/agent-helpers";
import { useSettingsData } from "../contexts/SettingsDataContext";
import { useActiveAgent } from "../contexts/ActiveAgentContext";

export const useFeatureFlags = () => {
  const { settings } = useSettingsData();
  const { activeAgent } = useActiveAgent();

  const TONY_BOLONEY_ATLANTIC_CITY = "agent_27b0e282e115f6fc5f1d9a0314";
  const TONY_BOLONEY_HOBOKEN = "agent_a61820da08d3061a5fb64645a2";
  const TONY_BOLONEY_JERSEY_CITY = "agent_dfb7aeb76a42f899e260a6ce14";
  const YAKITORI_SUSHI_HOUSE = "agent_b15bda4b65b40cd1958b02d4fc";
  const ZOLLOS_PIZZA = "agent_3429ea28f1dc5c7bd011f05b41";
  const BEAST_CRAFT_BBQ_CO_BELLEVILLE = "agent_0206a6355d286c62cec782b56b";
  const UPPER_CRUST_LAKEWOOD = "agent_8bb707b7281f31d6999dfac068";
  const EL_RANCHO_GRANDE_MIAMI = "agent_206d0031c1ef806321680ff8ed";
  const UNCLE_ERNIES_PIZZA_CHATSWORTH = "agent_e44cd169ee6552fcf41625913b";
  const LA_NOVA_PIZZA_AND_STEAK = "agent_e154422cebccd1f5c095848e82";
  const LAGUNA_LOUNGE_GRANT_AVE = "agent_0b6e769d2f33069ad888971c98";
  const TITOS_LOUNGE_URBANDALE = "agent_e95e4d4864f1a5baac11f41b44";
  const ENCANTADA_COCINA_CANTINA_GEORGETOWN =
    "agent_3f393319d562fbb283fcdbae57";
  const PIZZICO_RISTORANTE_BAR_NASHUA = "agent_9865e231c7e6280b1d048fda51";
  const PIZZICO_RISTORANTE_BAR_MERRIMACK = "agent_f8a0c143891ad2ff30ea8718b6";
  const ANCHOR_STONE_DECK_PIZZA_NEWBURYPORT =
    "agent_a81563db7b72243f5d946c82fe";
  const SEATTLE_PIZZA_AND_BAR = "agent_52575b0468b2e3f68df8044b64";
  const MAMAWS_CAFE_AND_CATERING_PRAGUE = "agent_6cc8ff83f12de900824f9f944e";
  const MERCATO_ROMAN_PIZZA_WESTWOOD = "agent_67f9fec697f3999c50926c2bf9";
  const MERCATO_ROMAN_PIZZA_KITCHEN_TAPPAN = "agent_41dfac87fc4d740fc67d76d908";
  const ROCCOS_PIZZERIA_NEW_PALTZ = "agent_225ea6880c91df585a29962ca9";
  const PAN_AND_PEEL_PIZZA_PEARL_RIVER = "agent_917572c6e0d7b22af25347f8f1";
  const BRUNOS_PIZZERIA_MARBLEHEAD = "agent_f24286a4f5281ac45d349d1702";
  const LOMBARDOUGHS_PIZZA_AND_BEER_FORT_MYERS =
    "agent_f28036be6a586a3efbd1b6487f";
  const PIZZA_PRESS_ORANGE = "agent_efcaef6aba02e968373a7e74db";
  const PIZZA_PRESS_IRVINE = "agent_217cb7fc4b5f23e48d4ada3099";
  const TRULY_PIZZA_DANA_POINT = "agent_646a2b987e4c720314b5e88af4";
  const CASABLANCA_LAKE_OZARK = "agent_4376b86e602f25afb8fa1a2ba1";
  const CHRISTIANS_PIZZA = "agent_c59b30d0a9e918acfd5ad19355";
  const SHELBYS_PIZZA_MCKINNEY = "agent_28ef86839bf1ed646d8105ee50";
  const GOODFELLAS_PIZZERIA_SHORT_NORTH = "agent_fdade3dbf9746a9603321cc17b";
  const INFERNO_PIZZA_NORTH_HUNTINGDON = "agent_eb567ca078d488fc8c2b97b5f7";
  const ELIZABETH_PIZZA_LEXINGTON = "agent_7385207ba82ed66c83f65d599d";
  const ALZARRAD_SYRIAN_EATERY_MURPHY = "agent_4d2e95ba6add9143b761baa195";
  const VICARIOS_PIZZA_BELLEFONTAINE = "agent_54f3e495d2cf871a15efdd8db3";
  const B_AND_C_TERIYAKI_MONROVIA = "agent_48269592beb506fb9e0d0d53b0";
  const BUFFALO_BOSS_BROOKLYNS_FINEST_WINGS =
    "agent_de9fd44c46e5ae949c0347fa5e";
  const DICE_PIZZA_TAMPA = "agent_9bb14c905a67b9ddb488680c8f";
  const MOUNTAIN_TRAIL_GRILL_AND_PIZZA = "agent_db65eabbe4a3ad7a075475f44f";
  const PIZZANOS_EXPRESS_COLUMBUS = "agent_a97c224d4dbd8f4f91bed41b6b";
  const NOT_JUST_WINGS_GLENOLDEN = "agent_32d608bc995945cb254fd80347";
  const GRUMPYS_SOURDOUGH_PIZZA = "agent_3cd1b1a637f838710987641bff";
  const MANAYUNK_PIZZA_PHILADELPHIA = "agent_22bd44ef5422d84a84cb9b255f";
  const RITAS_OF_HOWELL = "agent_c566392e711c3e2830373a3aee";
  const RITAS_OF_LAKEWOOD = "agent_34807215bccf3ef30e0307800d";
  const TAGLIO_PIZZA = "agent_6cf5b84819c87589a52ae1e281";
  const TAGLIO_PIZZA_MASSAPEQUA = "agent_cb6570c992b93e0b6222017740";

  const PAYMENTS_BETA_TESTERS = [
    TONY_BOLONEY_ATLANTIC_CITY,
    TONY_BOLONEY_HOBOKEN,
    TONY_BOLONEY_JERSEY_CITY,
    YAKITORI_SUSHI_HOUSE,
    ZOLLOS_PIZZA,
    BEAST_CRAFT_BBQ_CO_BELLEVILLE,
    UPPER_CRUST_LAKEWOOD,
    EL_RANCHO_GRANDE_MIAMI,
    UNCLE_ERNIES_PIZZA_CHATSWORTH,
    LA_NOVA_PIZZA_AND_STEAK,
    LAGUNA_LOUNGE_GRANT_AVE,
    TITOS_LOUNGE_URBANDALE,
    ENCANTADA_COCINA_CANTINA_GEORGETOWN,
    PIZZICO_RISTORANTE_BAR_NASHUA,
    PIZZICO_RISTORANTE_BAR_MERRIMACK,
    ANCHOR_STONE_DECK_PIZZA_NEWBURYPORT,
    SEATTLE_PIZZA_AND_BAR,
    MAMAWS_CAFE_AND_CATERING_PRAGUE,
    MERCATO_ROMAN_PIZZA_WESTWOOD,
    MERCATO_ROMAN_PIZZA_KITCHEN_TAPPAN,
    ROCCOS_PIZZERIA_NEW_PALTZ,
    PAN_AND_PEEL_PIZZA_PEARL_RIVER,
    BRUNOS_PIZZERIA_MARBLEHEAD,
    LOMBARDOUGHS_PIZZA_AND_BEER_FORT_MYERS,
    PIZZA_PRESS_ORANGE,
    PIZZA_PRESS_IRVINE,
    TRULY_PIZZA_DANA_POINT,
    CASABLANCA_LAKE_OZARK,
    CHRISTIANS_PIZZA,
    SHELBYS_PIZZA_MCKINNEY,
    GOODFELLAS_PIZZERIA_SHORT_NORTH,
    INFERNO_PIZZA_NORTH_HUNTINGDON,
    ELIZABETH_PIZZA_LEXINGTON,
    ALZARRAD_SYRIAN_EATERY_MURPHY,
    VICARIOS_PIZZA_BELLEFONTAINE,
    B_AND_C_TERIYAKI_MONROVIA,
    BUFFALO_BOSS_BROOKLYNS_FINEST_WINGS,
    DICE_PIZZA_TAMPA,
    MOUNTAIN_TRAIL_GRILL_AND_PIZZA,
    PIZZANOS_EXPRESS_COLUMBUS,
    NOT_JUST_WINGS_GLENOLDEN,
    GRUMPYS_SOURDOUGH_PIZZA,
    MANAYUNK_PIZZA_PHILADELPHIA,
    RITAS_OF_HOWELL,
    RITAS_OF_LAKEWOOD,
    TAGLIO_PIZZA,
    TAGLIO_PIZZA_MASSAPEQUA,
  ];

  return {
    isPaymentsFeatureEnabled: () => {
      // enabled on local
      if (process.env.NODE_ENV === "development") {
        return true;
      }

      // only show for whitelisted beta testers
      return (
        activeAgent?.id &&
        (isStreamOrderingAgent(
          activeAgent?.type,
          settings?.posProvider === "stream"
        ) ||
          isSquareOrderingAgent(
            activeAgent?.type,
            settings?.posProvider === "square"
          )) &&
        PAYMENTS_BETA_TESTERS.includes(activeAgent?.id)
      );
    },
  };
};
